
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M392.856 256.627v15.011c0 75.463-61.393 136.855-136.855 136.855S119.146 347.1 119.146 271.638c0-75.463 61.393-136.856 136.855-136.856a137.33 137.33 0 0147.912 8.639l-52.373 59.481 218.602 12.376L430.198 0 374.95 62.745C338.815 42.121 297.958 31.276 256 31.276c-64.203 0-124.563 25.002-169.961 70.401-45.399 45.399-70.401 105.758-70.401 169.961S40.64 396.201 86.039 441.599C131.438 486.997 191.797 512 256 512s124.563-25.001 169.961-70.401c45.399-45.399 70.401-105.758 70.401-169.961v-15.011H392.856z"}})])
          )
        }
      }
    